var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      attrs: {
        disabled: !_vm.resettableData || _vm.resettableData.length == 0,
        small: "",
        color: "secondary lighten-1",
      },
      on: { click: _vm.reset },
    },
    [
      _c("v-icon", [_vm._v("settings_backup_restore")]),
      _vm._v("\n  Undo changes\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }